// extracted by mini-css-extract-plugin
export default {"info":"Info--info--ZOcm5","infoText":"Info--infoText--ojN7d","infoIcon":"Info--infoIcon--dKbeG","open":"Info--open--hRVFB"};